import React, { Component } from "react";
import { Button, Row, Col, Alert, InputGroup } from "reactstrap";

import { ClientForm } from "./ClientForm";
import { LoadingModal } from "./LoadingModal";

import { RepForm } from "./RepForm";

import { FetchData } from "./utils/DataFetch";
import { GetCookie, Timeout } from "./utils/Common";

import AddIcon from "../images/add.png";

import { ClientTableDefault } from "./ClientTableDefault";
import { ClientTableReps } from "./ClientTableReps";

export class Client extends Component {
  static displayName = Client.name;

  constructor(props) {
    super(props);
    this.state = {
      clientList: [],
      clickCount: 0,
      loading: false,
      fetchingData: false,

      modal: false,
      modalRepForm: false,

      selectedClient: null,

      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      model: {
        EventType: "insert",
        ClientId: null,
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
        ClientPhoneFax: "",
        ClientName: "",
        ClientMailStreet: "",
        ClientMailStreet2: "",
        ClientMailCity: "",
        ClientMailState: "",
        ClientMailZip: "",
        ClientStreet: "",
        ClientStreet2: "",
        ClientCity: "",
        ClientState: "",
        ClientZip: "",
        ClientCountry: "",
        ClientDiscount: null,
        ClientNotes: "",
        ClientCreditCard: "",
        ClientEmailForInvoice: "",
        ClientEmail: "",
        ClientWebsite: "",
        ClientOrg: "",
        ClientBillRateType: "",
        ClientInactiveFlg: false,
        ClientInvoiceNote: "",
        FeeAuth: "Not authorized yet",
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      rep: {
        EventType: "insert",
        RepId: null,
        ClientId: null,
        RepLastName: "",
        RepFirstName: "",
        RepPhone: "",
        RepPhone2: "",
        RepNote: "",
        RepZip: "",
        RepEmail: "",
        RepInactiveFlg: false,
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: "",
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
        ClientEmail: "",
      },
      searchModel: {
        ClientId: "",
        ClientName: "",
        ClientAbbrv: "",
        Org: "",
        Phone: "",
        SortBy: "clientName",
        SortDirection: "asc",
      },
      repSearchModel: {
        RepName: "",
        RepPhone: "",
        Client: "",
        ClientId: "",
        ClientAbbrv: "",
        Inactive: false,
        SortBy: "repLastName",
        SortDirection: "asc",
      },
      reps: [],
    };
    this.user = JSON.parse(GetCookie("user"));
    //this.clickCount = 0;
    //this.singleClickTimer = '';

    this.setModal = this.setModal.bind(this);
    this.setModalRep = this.setModalRep.bind(this);
    //
    //this.handleClicks = this.handleClicks.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.handleSaveRepFormEventSuccess =
      this.handleSaveRepFormEventSuccess.bind(this);
    //
    this.handleDoubleClickRep = this.handleDoubleClickRep.bind(this);
    this.handleDoubleClickClient = this.handleDoubleClickClient.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.addRep = this.addRep.bind(this);

    this.renderWorkOrderTable = this.renderClientTable.bind(this);
    this.renderRepTable = this.renderRepTable.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleRepSearchChange = this.handleRepSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyDownRepSearch = this.handleKeyDownRepSearch.bind(this);
    //
    this.handleDeleteRep = this.handleDeleteRep.bind(this);
    //
    //    this.onClickResizeColumn = this.onClickResizeColumn.bind(this);
    //    this.handleOnMouseUp = this.handleOnMouseUp.bind(this);
  }

  componentDidMount() {
    //this.populateClientData();
  }

  setModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  setModalRep() {
    this.setState({ modalRepForm: !this.state.modalRepForm });
  }

  resetFields() {
    this.setState((prevState) => ({
      model: {
        EventType: "insert",
        ClientId: null,
        ClientAbbrv: "",
        ClientPhone: "",
        ClientPhone2: "",
        ClientPhoneFax: "",
        ClientName: "",
        ClientMailStreet: "",
        ClientMailStreet2: "",
        ClientMailCity: "",
        ClientMailState: "",
        ClientMailZip: "",
        ClientStreet: "",
        ClientStreet2: "",
        ClientCity: "",
        ClientState: "",
        ClientZip: "",
        ClientCountry: "",
        ClientDiscount: null,
        ClientNotes: "",
        ClientCreditCard: "",
        ClientEmailForInvoice: "",
        ClientEmail: "",
        ClientWebsite: "",
        ClientOrg: "",
        ClientBillRateType: "",
        ClientInactiveFlg: false,
        ClientInvoiceNote: "",
        FeeAuth: "Not authorized yet",
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
    }));

    this.setModal();
  }

  addRep() {
    this.setState((prevState) => ({
      rep: {
        EventType: "insert",
        RepId: null,
        ClientId: this.state.selectedClient.clientId,
        RepLastName: "",
        RepFirstName: "",
        RepPhone: "",
        RepPhone2: "",
        RepNote: "",
        RepZip: "",
        RepEmail: "",
        RepInactiveFlg: false,
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: this.state.selectedClient.clientName,
        ClientAbbrv: this.state.selectedClient.clientAbbrv,
        ClientPhone: this.state.selectedClient.clientPhone,
        ClientPhone2: this.state.selectedClient.clientPhon2,
        ClientEmail: this.state.selectedClient.clientEmail,
      },
    }));

    this.setModalRep();
  }

  handleDoubleClickClient = (clientData) => {
    let searchModel = {
      ClientId: clientData.data.clientId,
      ClientName: "",
      ClientAbbrv: "",
      Org: "",
      Phone: "",
      SortBy: "",
      SortDirection: "",
    };

    FetchData("/getclients", "POST", this.user.token, searchModel).then(
      (data) => {
        this.setState(
          {
            selectedClient: clientData.data,
            model: {
              ...this.state.model, // Spread the existing state
              EventType: "update",
              ClientId: clientData.data.clientId,
              ClientAbbrv: clientData.data.clientAbbrv,
              ClientPhone: clientData.data.clientPhone,
              ClientPhone2: clientData.data.clientPhone2,
              ClientPhoneFax: clientData.data.clientPhoneFax,
              ClientName: clientData.data.clientName,
              ClientMailStreet: clientData.data.clientMailStreet,
              ClientMailStreet2: clientData.data.clientMailStreet2,
              ClientMailCity: clientData.data.clientMailCity,
              ClientMailState: clientData.data.clientMailState,
              ClientMailZip: clientData.data.clientMailZip,
              ClientStreet: clientData.data.clientStreet,
              ClientStreet2: clientData.data.clientStreet2,
              ClientCity: clientData.data.clientCity,
              ClientState: clientData.data.clientState,
              ClientZip: clientData.data.clientZip,
              ClientCountry: clientData.data.clientCountry,
              ClientDiscount: clientData.data.clientDiscount,
              ClientNotes: clientData.data.clientNotes,
              ClientCreditCard: clientData.data.clientCreditCard,
              ClientEmailForInvoice: clientData.data.clientEmailForInvoice,
              ClientEmail: clientData.data.clientEmail,
              ClientWebsite: clientData.data.clientWebsite,
              ClientOrg: clientData.data.clientOrg,
              ClientBillRateType: clientData.data.clientBillRateType,
              ClientInactiveFlg: clientData.data.clientInactiveFlg,
              ClientInvoiceNote: clientData.data.clientInvoiceNote,
              FeeAuth: clientData.data.feeAuth,
              CreateDateTime: clientData.data.createDateTime,
              CreateByUserId: clientData.data.createByUserId,
              UpdateByUserId: clientData.data.updateByUserId,
              UpdateDateTime: clientData.data.updateDateTime,
              IsDeletedFlg: clientData.data.isDeletedFlg,
            },
          },
          () => this.setModal()
        ); // After state update, toggle modal visibility
      }
    );
  };

  handleDoubleClickRep(repData) {
    this.setState((prevState) => ({
      rep: {
        EventType: "update",
        ClientId: repData.data.clientId,
        RepId: repData.data.repId,
        ClientId: repData.data.clientId,
        RepLastName: repData.data.repLastName,
        RepFirstName: repData.data.repFirstName,
        RepPhone: repData.data.repPhone,
        RepPhone2: repData.data.repPhone2,
        RepNote: repData.data.repNote,
        RepZip: repData.data.repZip,
        RepEmail: repData.data.repEmail,
        RepInactiveFlg: repData.data.repInactiveFlg,
        CreateDateTime: repData.data.createDateTime,
        CreatebyUserId: repData.data.createbyUserId,
        UpdateByUserId: repData.data.updateByUserId,
        UpdateDateTime: repData.data.updateDateTime,
        IsDeletedFlg: repData.data.isDeletedFlg,
        ClientName: repData.data.clientName,
        ClientAbbrv: repData.data.clientAbbrv,
        ClientPhone: repData.data.clientPhone,
        ClientPhone2: repData.data.clientPhone2,
        ClientEmail: repData.data.clientEmail,
      },
    }));
    this.setModalRep();
  }

  handleClick = (clientData) => {
    this.setState({ clickCount: this.state.clickCount + 1 });
    this.clickTimer = setTimeout(() => {
      if (this.state.clickCount === 1) {
        // Single click action
        this.setState(
          { fetchingData: true, selectedClient: clientData.data },
          () => {
            this.populateRepData();
          }
        );
      }
      this.setState({ clickCount: 0 }); // Reset click count after action
    }, 300); // Delay of 300ms
  };

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
        selectedClient: alert.selectedClient ? alert.selectedClient : null,
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateClientData();
      }
    );
  }

  handleSaveRepFormEventSuccess(alert) {
    this.setState(
      {
        modalRepForm: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateRepData();
      }
    );
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };

    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleRepSearchChange(e) {
    let model = { ...this.state.repSearchModel };

    if (e.target.type === "checkbox") model[e.target.name] = e.target.checked;
    else model[e.target.name] = e.target.value;

    this.setState({ repSearchModel: model });
  }

  handleDeleteRep(repData) {
    var model = { ...this.state.rep };
    model.EventType = "delete";
    model.ClientId = repData.clientId;
    model.RepId = repData.repId;
    model.ClientId = repData.clientId;
    model.RepLastName = repData.repLastName;
    model.RepFirstName = repData.repFirstName;
    model.RepPhone = repData.repPhone;
    model.RepPhone2 = repData.repPhone2;
    model.RepNote = repData.repNote;
    model.RepZip = repData.repZip;
    model.RepEmail = repData.repEmail;
    model.RepInactiveFlg = repData.repInactiveFlg;
    model.CreateDateTime = repData.createDateTime;
    model.CreatebyUserId = repData.createbyUserId;
    model.UpdateByUserId = repData.updateByUserId;
    model.UpdateDateTime = repData.updateDateTime;
    model.IsDeletedFlg = true;
    model.ClientName = repData.clientName;
    model.ClientAbbrv = repData.clientAbbrv;
    model.ClientPhone = repData.clientPhone;
    model.ClientPhone2 = repData.clientPhone2;
    model.ClientEmail = repData.clientEmail;

    FetchData("/saverep", "POST", this.user.token, model).then((data) => {
      this.handleSaveEventSuccess({
        message:
          data === "Success" ? "Rep has been deleted successfully" : data,
        modal: false,
        color: data === "Success" ? "success" : "warning",
        selectedClient: this.state.selectedClient,
      });
      this.populateRepData();
    });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.setState({ reps: [] });
      this.populateClientData();
    }
  }

  handleKeyDownRepSearch(e) {
    if (e.key === "Enter") {
      this.populateRepDataSearch();
    }
  }

  async populateClientData() {
    this.setState({ fetchingData: true });

    await FetchData(
      "/getclients",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ clientList: data, loading: false, fetchingData: false });
    });
  }

  populateRepData() {
    let model = {
      ClientId: this.state.selectedClient.clientId,
    };

    FetchData("/getreps", "POST", this.user.token, model).then((data) => {
      this.setState({ reps: data, fetchingData: false });
    });
  }

  populateRepDataSearch() {
    var model = { ...this.state.repSearchModel };
    model.ClientId = this.state.selectedClient.clientId;

    FetchData("/getreps", "POST", this.user.token, model).then((data) => {
      this.setState({ reps: data, fetchingData: false });
    });
  }

  renderClientTable() {
    return (
      <ClientTableDefault
        clients={this.state.clientList}
        handleClick={this.handleClick}
        handleDoubleClickClient={this.handleDoubleClickClient}
      />
    );
  }

  renderRepTable() {
    return (
      <ClientTableReps
        reps={this.state.reps}
        handleDoubleClickRep={this.handleDoubleClickRep}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderClientTable(this.state.clientList)
    );

    let repsContent = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRepTable(this.state.reps)
    );

    return (
      <div style={{ paddingTop: "12px", overflow: "hidden" }}>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tableLabel">Clients</h5>
        <Row>
          <Col>
            <InputGroup size="sm">
              <Button color="btn" onClick={this.resetFields} size="sm">
                <img
                  src={AddIcon}
                  style={{ width: "16px", height: "16px" }}
                  alt="Add"
                />{" "}
                New
              </Button>
              <input
                name="ClientAbbrv"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientAbbrv}
                onChange={this.handleSearchChange}
                placeholder="Abbrv"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="ClientName"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.ClientName}
                onChange={this.handleSearchChange}
                placeholder="Client Name"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Org"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Org}
                onChange={this.handleSearchChange}
                placeholder="Org"
                onKeyDown={this.handleKeyDown}
              />
              <input
                name="Phone"
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.Phone}
                onChange={this.handleSearchChange}
                placeholder="Phone"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <LoadingModal fetchingData={this.state.fetchingData} />

        {this.state.modal && (
          <ClientForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
          />
        )}

        <div>{contents}</div>
        <hr />
        {this.state.selectedClient != null && (
          <div>
            <h5 id="tableLabel">Reps</h5>
            <Row style={{ marginTop: "10px" }}>
              <Col>
                <InputGroup size="sm">
                  <Button color="btn" onClick={this.addRep} size="sm">
                    <img
                      src={AddIcon}
                      style={{ width: "16px", height: "16px" }}
                      alt="Add"
                    />{" "}
                  </Button>
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <div>{repsContent}</div>
              </Col>
            </Row>
          </div>
        )}

        {this.state.modalRepForm && (
          <RepForm
            model={this.state.rep}
            modal={this.state.modalRepForm}
            alert={this.state.alert}
            setModal={this.setModalRep}
            handleSaveEventSuccess={this.handleSaveRepFormEventSuccess}
          />
        )}
      </div>
    );
  }
}
